<template>
  <section>
    <v-dialog
      content-class="radius-20"
      persistent
      v-model="showDialog"
      max-width="900px"
    >
      <v-card class="py-4">
        <v-card-text class="form-body-container">
          <v-form ref="scmTransactionForm" v-model="validForm" class="form-box">
            <v-row>
              <v-col cols="12">
                <h2 class="mb-10 mt-4 color-dark">
                  {{ $t("add_transaction") }}
                </h2>
                <h3 class="mb-5 color-dark">{{ $t("sub_inventory") }}</h3>
              </v-col>

              <v-col class="py-0" cols="12" sm="8">
                <v-autocomplete
                  v-model="scmTransactionInfo.transaction_type"
                  :items="transactionsTypes"
                  :rules="[rules.required]"
                  item-text="name"
                  item-value="id"
                  regular
                  dense
                  :label="$t('table.transaction_type')"
                ></v-autocomplete>
              </v-col>
              <v-col class="py-0" cols="12" sm="4">
                <v-text-field
                  v-model="scmTransactionInfo.reference_number"
                  :rules="[rules.maxLen(191)]"
                  :label="$t('table.ref_no')"
                  regular
                  dense
                ></v-text-field>
              </v-col>
              <!-- v-if="scmTransactionInfo.transaction_type" -->
              <template>
                <v-col class="py-0" cols="12" sm="6">
                  <v-autocomplete
                    v-model="scmTransactionInfo.inventory"
                    :items="subInventories"
                    :rules="[rules.required]"
                    item-text="name"
                    item-value="id"
                    regular
                    dense
                    :label="
                      selectedSCMTransactionTypeInfo.need_two_inventories
                        ? `${$t('table.from_sub_inventory')}`
                        : `${$t('sub_inventory')}`
                    "
                    @change="setLocatorType"
                  ></v-autocomplete>
                </v-col>

                <v-col
                  v-if="selectedSCMTransactionTypeInfo.need_two_inventories"
                  class="py-0"
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="scmTransactionInfo.to_inventory"
                    :items="toSubInventories"
                    :rules="[rules.required]"
                    item-text="name"
                    item-value="id"
                    regular
                    dense
                    :disabled="!scmTransactionInfo.inventory"
                    :label="$t('table.to_sub_inventory')"
                    @change="setToLocatorType"
                  ></v-autocomplete>
                </v-col>

                <v-col
                  v-if="scmTransactionInfo.locator_type !== 'none'"
                  class="py-0"
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="scmTransactionInfo.locator"
                    :items="locators"
                    :rules="[rules.required]"
                    item-text="name"
                    item-value="id"
                    regular
                    dense
                    :loading="loadingLocators"
                    :disabled="
                      !scmTransactionInfo.locator_type || loadingLocators
                    "
                    :label="
                      selectedSCMTransactionTypeInfo.need_two_inventories
                        ? `${$t('table.from_locator')}`
                        : `${$t('table.locator')}`
                    "
                    @change="showCorrectItem"
                  ></v-autocomplete>
                </v-col>

                <v-col
                  v-if="
                    selectedSCMTransactionTypeInfo.need_two_inventories &&
                    scmTransactionInfo.to_locator_type &&
                    scmTransactionInfo.to_locator_type !== 'none'
                  "
                  class="py-0"
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="scmTransactionInfo.to_locator"
                    :items="toLocators"
                    :rules="[rules.required]"
                    item-text="name"
                    item-value="id"
                    regular
                    dense
                    :loading="loadingToLocators"
                    :disabled="
                      !scmTransactionInfo.to_locator_type || loadingToLocators
                    "
                    :label="$t('table.to_locator')"
                  ></v-autocomplete>
                </v-col>

                <v-col class="py-0" cols="12">
                  <v-dialog
                    ref="dateDialog"
                    v-model="date_modal"
                    :return-value.sync="scmTransactionInfo.date"
                    persistent
                    width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        :rules="[rules.required]"
                        v-model="scmTransactionInfo.date"
                        label="Date"
                        readonly
                        clearable
                        v-on="on"
                        append-icon="icon-calendar"
                      ></v-text-field>
                    </template>
                    <v-date-picker v-model="scmTransactionInfo.date" scrollable>
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="date_modal = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="$refs.dateDialog.save(scmTransactionInfo.date)"
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                  <!-- <p class="mb-0">
                    {{ $t("date_time") }}
                  </p>
                  <date-time-picker
                    v-model.trim="scmTransactionInfo.date"
                    :date-time="scmTransactionInfo.date"
                    :textFieldProps="{ regular: true }"
                    timeFormat="HH:mm:ss"
                    :allowedDates="allowedDates"
                  ></date-time-picker> -->
                </v-col>
                <v-col class="py-0" cols="12">
                  <v-textarea
                    v-model="scmTransactionInfo.description"
                    :rules="[rules.maxLen(5000)]"
                    rows="1"
                    :label="$t('table.description')"
                    regular
                    dense
                  ></v-textarea>
                </v-col>
              </template>
              <v-col class="pb-0" cols="12" sm="3">
                <v-autocomplete
                  v-model="categorySelected"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  regular
                  dense
                  :label="$t('table.categories')"
                  @change="showItemsRelated"
                ></v-autocomplete>
              </v-col>
              <v-col class="pb-0" cols="12" sm="9">
                <v-autocomplete
                  v-model="scmTransactionInfo.item"
                  :rules="[rules.required]"
                  :items="scmItems"
                  item-text="code_name"
                  item-value="id"
                  regular
                  dense
                  :label="$t('table.items')"
                  @change="showItemDetails"
                ></v-autocomplete>
              </v-col>

              <template>
                <v-col cols="12">
                  <h3>{{ $t("item_info") }}</h3>
                </v-col>

                <v-col class="py-0" cols="12" sm="3">
                  <v-text-field
                    :value="selectedSCMItemInfo.code"
                    :label="$t('table.item_code')"
                    regular
                    dense
                    readonly
                    disabled
                  ></v-text-field>
                </v-col>

                <v-col class="py-0" cols="12" sm="6">
                  <v-text-field
                    :value="selectedSCMItemInfo.name"
                    :label="$t('table.item_name')"
                    regular
                    dense
                    readonly
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col class="py-0" cols="12" sm="3">
                  <v-text-field
                    v-model.number="scmTransactionInfo.qty"
                    :rules="[
                      rules.required,
                      rules.integer,
                      rules.minVal(1),
                      rules.maxVal(calcMaxQty),
                    ]"
                    :label="$t('table.qty')"
                    regular
                    dense
                  ></v-text-field>
                </v-col>

                <template>
                  <!-- v-if="scmTransactionInfo.inventory" -->
                  <v-col
                    class="py-0 d-flex justify-space-between"
                    cols="12"
                    sm="3"
                  >
                    <h4 class="grey--text mr-2">Available</h4>
                    <h4 class="grey--text">{{ qtyAvailable }}</h4>
                  </v-col>

                  <v-col
                    class="py-0 d-flex justify-space-between"
                    cols="12"
                    sm="3"
                  >
                    <h4 class="grey--text mr-2">On-hand</h4>
                    <h4 class="grey--text">{{ qtyOnHand }}</h4>
                  </v-col>
                </template>
              </template>
            </v-row>
          </v-form>
          <slot></slot>
        </v-card-text>

        <v-divider class="pb-2"></v-divider>
        <v-card-actions class="px-5">
          <template v-if="listAdded.length > 0">
            <v-btn v-if="existed" text @click="listDialog = true">{{
              $t("button.show_list")
            }}</v-btn>
          </template>
          <v-spacer></v-spacer>
          <v-btn
            class="mx-1 px-7 radius-12"
            color="primary"
            outlined
            dense
            @click="cancel"
          >
            <small>{{ $t("button.cancel") }}</small>
          </v-btn>

          <v-btn
            class="px-5 radius-12"
            color="success"
            :loading="loading"
            :disabled="!validForm || loading"
            @click="saveSCMTransaction"
          >
            <small>{{ $t("button.save_close") }}</small>
          </v-btn>
          <v-btn
            class="px-5 radius-12"
            color="primary"
            :loading="loadingActionAdd"
            @click="saveAndAdd"
            :disabled="!validForm || loadingActionAdd"
          >
            <small>{{ $t("button.save_new") }}</small>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="listDialog">
      <v-card class="pa-5">
        <h2 class="mb-6">{{ $t("heading.added_transactions") }}</h2>
        <v-data-table
          :headers="scmTransactionsTableHeaders"
          :items="listAdded"
          :mobile-breakpoint="0"
          :items-per-page="200"
          hide-default-footer
          class="table"
        >
          <template v-slot:item="{ item }">
            <tr class="table__row">
              <td class="table__cell text-center">
                <span> {{ (item.item && item.item.code) || "-" }} </span>
              </td>

              <td class="table__cell name text-center">
                <span> {{ (item.item && item.item.name) || "-" }} </span>
              </td>

              <td class="table__cell text-center">
                <span> {{ (item.type && item.type.name) || "-" }} </span>
              </td>

              <td class="table__cell text-center">
                <span> {{ item.qty || "-" }} </span>
              </td>

              <td class="table__cell text-center">
                <span>
                  {{ (item.inventory && item.inventory.name) || "-" }}
                </span>
              </td>

              <td class="table__cell text-center">
                <span> {{ item.locator_name || "-" }} </span>
              </td>

              <td class="table__cell text-center">
                <span> {{ (item.date && item.date.date) || "-" }} </span>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import { IndexData, ShowData } from "@/helpers/apiMethods";

export default {
  name: "SCMTransactionsAddDialogComponent",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    loadingActionAdd: {
      type: Boolean,
      required: true,
    },
    scmTransactionInfo: {
      type: Object,
      required: true,
    },
    existed: {
      type: Boolean,
      default: false,
    },

    subInventories: {
      type: Array,
      required: true,
    },
    transactionsTypes: {
      type: Array,
      required: true,
    },
    listAdded: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      validForm: true,
      listDialog: false,
      date_modal: false,
      categorySelected: "",
      qtyOnHand: "0",
      qtyAvailable: "0",
      inventoryData: {},
      rules: {
        required: (val) => !!val || val === 0 || "This field is required",
        integer: (val) =>
          !val ||
          (!isNaN(Number(val)) && Number.isInteger(Number(val))) ||
          "This field's value must be integer",
        maxLen(max) {
          return (v) =>
            ((v && v.trim()) || "").length <= max ||
            `This field can't contain more than ${max} characters`;
        },
        maxVal(max) {
          return (v) =>
            v <= max ||
            max === -1 ||
            `This field's value can't be greater than ${max}`;
        },
        minVal(min) {
          return (v) =>
            v >= min || `This field's value can't be less than ${min}`;
        },
      },
      scmItems: [],
      locators: [],
      toLocators: [],
      categories: [],

      showDateMenu: false,
      showTimeMenu: false,
      loadingSCMItems: true,
      loadingLocators: false,
      loadingToLocators: false,
    };
  },
  components: {
    // DateTimePicker: () => import("@/components/DateTimePicker"),
  },
  created() {
    this.indexCategories();
    this.indexItems();
  },
  computed: {
    showDialog: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },

    scmTransactionsTableHeaders() {
      return [
        {
          text: this.$t("table.itemCode"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.name"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.transaction_type"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.transaction_qty"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.sub_inventory"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.locator"),
          align: "center",
          sortable: false,
        },
        {
          text: this.$t("table.transaction_date"),
          align: "center",
          sortable: false,
        },
      ];
    },
    selectedSCMItemInfo() {
      const selectedSCMItem = this.scmTransactionInfo.item
        ? this.scmItems.find((item) => item.id === this.scmTransactionInfo.item)
        : {};
      return selectedSCMItem || {};
    },
    selectedSCMTransactionTypeInfo() {
      const selectedSCMTransactionType = this.scmTransactionInfo
        .transaction_type
        ? this.transactionsTypes.find(
            (transactionType) =>
              transactionType.id === this.scmTransactionInfo.transaction_type
          )
        : {};
      return selectedSCMTransactionType || {};
    },
    selectedSCMInventoryInfo() {
      const selectedSCMInventory = this.scmTransactionInfo.inventory
        ? this.subInventories.find(
            (inventory) => inventory.id === this.scmTransactionInfo.inventory
          )
        : {};
      return selectedSCMInventory || {};
    },
    selectedSCMToInventoryInfo() {
      const selectedSCMToInventory = this.scmTransactionInfo.to_inventory
        ? this.subInventories.find(
            (inventory) => inventory.id === this.scmTransactionInfo.to_inventory
          )
        : {};
      return selectedSCMToInventory || {};
    },
    toSubInventories() {
      if (!this.scmTransactionInfo.inventory) {
        return [];
      }
      if (this.scmTransactionInfo.locator_type !== "none") {
        return this.subInventories;
      }

      return this.subInventories.map((subInventory) => ({
        ...subInventory,
        disabled: subInventory.id === this.scmTransactionInfo.inventory,
      }));
    },
    calcMaxQty() {
      return this.selectedSCMTransactionTypeInfo.action &&
        this.selectedSCMTransactionTypeInfo.action.id === 2
        ? -1
        : this.qtyOnHand;
    },
  },
  // async mounted() {
  //   await this.fetchSCMItems();
  // },
  methods: {
    cancel() {
      this.showDialog = false;
      this.qtyOnHand = "0";
      this.qtyAvailable = "0";
      this.indexItems();
      this.$emit("resetTransactionInfo");
    },
    showItemsRelated(category) {
      IndexData({
        reqName: "scm/items",
        query: { pagination: "all", category: category },
      })
        .then((res) => {
          const { data } = res.data;
          this.scmItems = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    allowedDates(value) {
      const previesDate = new Date(value);
      const currentDate = new Date(new Date().setDate(new Date().getDate()));
      return previesDate < currentDate;
    },
    // async fetchSCMItems() {
    //   try {
    //     const res = await IndexData({
    //       reqName: "scm/items",
    //       query: { pagination: "all", active: "yes" },
    //     });
    //     this.scmItems = res.data.data;
    //   } catch (err) {
    //     console.log();
    //   } finally {
    //     this.loadingSCMItems = false;
    //   }
    // },
    indexCategories() {
      IndexData({ reqName: "scm/categories" })
        .then((res) => {
          const { data } = res.data;
          this.categories = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    indexItems() {
      IndexData({
        reqName: "scm/items",
        query: { pagination: "all", active: "yes" },
      })
        .then((res) => {
          const { data } = res.data;
          this.scmItems = data;
        })
        .catch(() => {})
        .finally(() => {});
    },
    async fetchLocators(isToLocators = false) {
      try {
        const reqName =
          this.scmTransactionInfo[
            `${isToLocators ? "to_locator_type" : "locator_type"}`
          ] === "camp"
            ? "scm/camps"
            : "scm/employees";

        if (isToLocators) {
          this.loadingToLocators = true;
        } else {
          this.loadingLocators = true;
        }
        const res = await IndexData({ reqName, query: { pagination: "all" } });
        if (isToLocators) {
          this.toLocators = this.formalizeToLocators(res.data.data);
        } else {
          this.locators = res.data.data;
        }
      } catch (err) {
        console.log();
      } finally {
        this.loadingLocators = false;
        this.loadingToLocators = false;
      }
    },
    setLocatorType(inventory) {
      ShowData({
        reqName: `scm/inventories`,
        id: inventory,
      })
        .then((res) => {
          const { inventory } = res.data;
          console.log(inventory);
          this.inventoryData = inventory;
        })
        .catch(() => {});
      this.showItemDetails();
      if (!this.selectedSCMInventoryInfo.id) {
        this.scmTransactionInfo.locator_type = "";
        return;
      }
      if (
        this.inventoryData.for_camps === 0 &&
        this.inventoryData.for_employees === 0
      ) {
        this.scmTransactionInfo.locator_type = "none";
      }
      if (
        !this.selectedSCMInventoryInfo.for_camps &&
        !this.selectedSCMInventoryInfo.for_employees
      ) {
        this.scmTransactionInfo.locator_type = "none";
        return;
      }

      this.scmTransactionInfo.locator_type = this.selectedSCMInventoryInfo
        .for_camps
        ? "camp"
        : "employee";
      this.scmTransactionInfo.locator = "";
      this.fetchLocators();
    },
    showItemDetails() {
      ShowData({
        reqName: `scm/items`,
        id: this.scmTransactionInfo.item,
        query: { inventory: this.scmTransactionInfo.inventory },
      })
        .then((res) => {
          const { item } = res.data;
          this.qtyOnHand = item.on_hand_qty;
          this.qtyAvailable = item.avaliable_qty;
        })
        .catch(() => {});
    },
    showCorrectItem(locator) {
      ShowData({
        reqName: `scm/items`,
        id: this.scmTransactionInfo.item,
        query: {
          inventory: this.scmTransactionInfo.inventory,
          locator_type: this.inventoryData.for_camps ? "camp" : "employee",
          locator_id: locator,
        },
      })
        .then((res) => {
          const { item } = res.data;
          this.qtyOnHand = item.on_hand_qty;
          this.qtyAvailable = item.avaliable_qty;
        })
        .catch(() => {});
    },
    setToLocatorType() {
      if (!this.selectedSCMToInventoryInfo.id) {
        this.scmTransactionInfo.to_locator_type = "";
        return;
      }
      if (
        !this.selectedSCMToInventoryInfo.for_camps &&
        !this.selectedSCMToInventoryInfo.for_employees
      ) {
        this.scmTransactionInfo.to_locator_type = "none";
        return;
      }

      this.scmTransactionInfo.to_locator_type = this.selectedSCMToInventoryInfo
        .for_camps
        ? "camp"
        : "employee";
      this.scmTransactionInfo.to_locator = "";
      if (
        this.scmTransactionInfo.locator_type ===
        this.scmTransactionInfo.to_locator_type
      ) {
        this.toLocators = this.formalizeToLocators(this.locators);
        return;
      }
      this.fetchLocators(true);
    },
    formalizeToLocators(locatorsList) {
      if (
        this.scmTransactionInfo.inventory !==
        this.scmTransactionInfo.to_inventory
      ) {
        return locatorsList;
      }

      return locatorsList.map((locator) => ({
        ...locator,
        disabled: locator.id === this.scmTransactionInfo.locator,
      }));
    },
    resetSelectedItemData() {
      Object.keys(this.scmTransactionInfo).forEach((key) => {
        if (key !== "item") {
          this.scmTransactionInfo[key] = key === "qty" ? 0 : "";
        }
      });
      this.locators = [];
      this.toLocators = [];
    },
    saveSCMTransaction() {
      this.indexItems();
      this.$emit("saveSCMTransaction");
      this.qtyAvailable = "0";
      this.qtyOnHand = "0";
    },
    saveAndAdd() {
      this.$emit("saveAndAdd");
    },
  },
  watch: {
    inventoryData: {
      handler(value) {
        if (value.for_camps === 0 && value.for_employees === 0) {
          this.scmTransactionInfo.locator_type = "none";
          this.scmTransactionInfo.to_locator_type = "none";
        }
      },
      immediate: true,
      deep: true,
    },
    showDialog: {
      handler(newVal, oldVal) {
        if (oldVal) {
          this.$emit("resetTransactionInfo");
          this.$refs.scmTransactionForm.reset();
        }
      },
    },
    // ["scmTransactionInfo.transaction_type"]: {
    //   handler() {
    //     this.scmTransactionInfo.to_locator_type = "";
    //     this.scmTransactionInfo.to_locator = "";
    //     this.scmTransactionInfo.qty = 0;
    //   },
    // },
    // ["scmTransactionInfo.item"]: {
    //   handler() {
    //     this.resetSelectedItemData();
    //   },
    // },
  },
};
</script>

<style lang="scss" scoped>
.form-body-container {
  max-height: 60vh;
  overflow: auto;
}
</style>
